<template>
    <div class="template-preview">
        <template v-if="template.type === 'text'">
            <div class="tprev-text">{{ excerpt }}</div>
        </template>

        <template v-else-if="template.type === 'affix'">
            <div class="tprev-affix">
                <span class="tprev-affix-part">{{ template.data && template.data.prefix }}</span>
                <span class="tprev-affix-dots">…</span>
                <span class="tprev-affix-part">{{ template.data && template.data.suffix }}</span>
            </div>
        </template>

        <template v-else-if="template.type === 'media'">
            <img v-if="isImage" :src="fileUrl" class="tprev-media" :alt="template.name">
            <img v-else-if="thumbnailUrl" :src="thumbnailUrl" class="tprev-media" :alt="template.name">
            <div v-else class="tprev-icon">
                <i class="fa-solid" :class="isVideo ? 'fa-video' : isPdf ? 'fa-file-pdf' : 'fa-file'"></i>
            </div>
            <span v-if="filesCount > 1" class="tprev-count">+{{ filesCount - 1 }}</span>
        </template>

        <template v-else>
            <div class="tprev-icon tprev-post">
                <i class="fa-solid fa-layer-group"></i>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'TemplatePreview',

    props: {
        template: {
            type: Object,
            required: true
        },
        showPostPreview: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        excerpt() {
            const text = (this.template.data && this.template.data.text) || ''
            return text.length > 60 ? `${text.slice(0, 60)}…` : text
        },

        files() {
            return (this.template.data && this.template.data.files) || []
        },

        filesCount() {
            return this.files.length
        },

        file() {
            return this.files[0] || null
        },

        fileUrl() {
            return this.file && this.file.url
        },

        // populated when the file was previously given a thumbnail (e.g. via ThumbnailSelector.vue at save time)
        thumbnailUrl() {
            return this.file && this.file.thumbnail
        },

        mimetype() {
            return (this.file && this.file.mimetype) || ''
        },

        isImage() {
            return this.mimetype.startsWith('image/')
        },

        isVideo() {
            return this.mimetype.startsWith('video/')
        },

        isPdf() {
            return this.mimetype === 'application/pdf'
        }
    }
}
</script>

<style lang="scss" scoped>
.template-preview {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 6px;
    overflow: hidden;
    background: #f5f6fa;
    display: flex;
    align-items: center;
    justify-content: center;

    .tprev-count {
        position: absolute;
        bottom: 2px;
        right: 2px;
        background: rgba(0, 0, 0, 0.65);
        color: #fff;
        font-size: 9px;
        font-weight: 600;
        padding: 1px 4px;
        border-radius: 4px;
    }

    .tprev-text {
        font-size: 9px;
        color: #666;
        padding: 4px;
        line-height: 1.2;
        overflow: hidden;
        width: 100%;
        height: 100%;
    }

    .tprev-affix {
        font-size: 9px;
        color: #666;
        text-align: center;
        padding: 2px;

        .tprev-affix-part {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .tprev-affix-dots {
            color: #ccd0dc;
        }
    }

    .tprev-media {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .tprev-icon {
        color: #9ba3b7;
        font-size: 14px;

        &.tprev-post {
            color: #6b1f4d;
        }
    }
}
</style>
